const debounceReferences = {}

export const debounce = ({ id, delay = 300, callback }) => {
  if (!id) throw new Error('debounce id is required')
  if (!callback) throw new Error('debounce callback is required')

  if (debounceReferences[id]) {
    clearTimeout(debounceReferences[id])
    delete debounceReferences[id]
  }

  debounceReferences[id] = setTimeout(callback, delay)
}

const throttleReferences = {}

export const throttle = async ({ id, callback }) => {
  if (!id) throw new Error('throttle id is required')
  if (!callback) throw new Error('throttle callback is required')

  if (throttleReferences[id]) {
    return
  }

  throttleReferences[id] = true
  try {
    await callback()
  } catch (e) {
    console.error(e)
    throw new Error(e)
  } finally {
    throttleReferences[id] = false
  }
}
